<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts">
	let i = 0;
</script>
<script setup lang="ts">
	import { useSlots, type Ref } from "vue";
	const modelValue = defineModel<string | number>();
	defineProps<{
		disabled?: boolean;
		label?: string;
		error?: string | Ref<string>;
		icon?: string;
		autocomplete?: string;
		placeholder?: string;
		step?: string;
	}>();
	defineEmits<{
		(e: "blur"): void;
	}>();
	const errorId = `dropdownerror${i++}`;

	const slots = useSlots();
</script>

<template>
	<label class="flex flex-col items-stretch relative pb-4">
		<span
			v-if="label"
			class="pl-4 mb-1 text-jca-dark-blue value-label"
			:class="{ 'pl-10': !!icon }"
		>
			{{ label }}
		</span>
		<div
			v-if="slots.prepend"
			class="absolute h-full left-0 top-0 flex items-center pointer-events-none"
		>
			<slot name="prepend" />
		</div>
		<div class="relative flex flex-col">
			<i
				class="absolute h-full right-2 top-0 flex items-center pointer-events-none"
			>
				<svg
					class="h-8"
					xmlns="http://www.w3.org/2000/svg"
					height="48"
					viewBox="0 -960 960 960"
					width="48"
				>
					<path
						d="M480-345 240-585l43-43 197 198 197-197 43 43-240 239Z"
						fill="currentColor"
					/>
				</svg>
			</i>
			<select
				v-model="modelValue"
				:disabled="disabled"
				:aria-describedby="errorId"
				:aria-invalid="!!error"
				class="text-jca-dark-blue body-2-bold py-2 pl-4 pr-10 rounded-[2rem] h-12 appearance-none border border-separator outline-none"
				:class="{ 'pl-12': slots.prepend }"
				@blur="$emit('blur')"
			>
				<option
					v-if="placeholder"
					value=""
					disabled
					selected
				>
					{{ placeholder }}
				</option>
				<slot />
			</select>
		</div>
		<span
			v-if="!!error && !disabled"
			:id="errorId"
			class="absolute left-4 bottom-0 error-text whitespace-nowrap"
		>
			{{ error }}
		</span>
	</label>
</template>

<style scoped></style>
